import React from "react";
import { TextField } from "@material-ui/core";
import ImageTooltip from "../../../common/HelpIconWithTooltip";
import { Typography } from "material-ui-core";
import { cpuCapacityDescription, cpuExample, localEndPointDescription } from "../../NTFS/ntfsConstants";
import { NTFS } from "../dataSourceConstants";

function NTFSInputField({
  label,
  value,
  placeholder,
  actionType,
  errorKey,
  classes,
  dispatch,
  removeErrorByKey,
  isEditMode,
  error,
  isNTFSServer,
}) {

  const renderDescription = () => {
    if(label === "Local Endpoints Group") {
      return localEndPointDescription;
    } else if (label === "Max CPU Capacity") {
      return cpuCapacityDescription;
    }
  }
  const styledDescription = (
    <Typography>
      <span className={classes.tooltipHeading}>{renderDescription()}</span>
      {label === "Max CPU Capacity" && <><br/><span className={classes.tooltipExample}>{cpuExample}</span></>}
      <br />
    </Typography>
  );
  return (
    <div className={classes.customPadding}>
      <div className={classes.tooltipContainer}>
        <div>
          {label}
          <span className={classes.customErrorIndication}>*</span>
        </div>
        {!isNTFSServer && label !== "Max File Size (MB)" && (
          <ImageTooltip description={styledDescription} loc={NTFS} />
        )}
      </div>

      <TextField
        required
        value={value}
        onChange={(event) => {
          dispatch({ type: actionType, payload: event.target.value });
          removeErrorByKey(errorKey);
        }}
        variant="outlined"
        fullWidth
        placeholder={placeholder}
      />

      {error && error[errorKey] ? (
        <div style={{ color: "red" }}>{error[errorKey]}</div>
      ) : null}
    </div>
  );
}

export default NTFSInputField;
